import Field from '@base/Form/Field';
import styled from '@emotion/styled';
import { Spacings, Fonts, mediaQuery } from '@styles/index';
import { isRequired } from '@cont/OfflineCentres/EnquiryPage/utils';
import Dropdown from '@comp/Dropdown/Dropdown';
import P2 from '@base/P2/P2';

const renderErrorMessage = ({ message }) => {
  return <Error>{message}</Error>;
};

const FormContainer = styled.form`
  width: 100%;
  margin-top: 0px;
  ${mediaQuery.aboveMobile} {
    margin-top: 0px;
    & > div:nth-child(1) {
      margin: 0;
    }
  }
`;

const FieldWrapper = styled.div`
  width: 328px;
  .MuiInputBase-root {
    height: ${Spacings.SPACING_14B};
    &.Mui-disabled {
      ${mediaQuery.aboveMobile} {
        input {
          border-radius: ${Spacings.SPACING_2B};
        }
      }
    }
    .MuiInputBase-input,
    .MuiInputBase-input::placeholder {
      font-size: ${Fonts.SMALL};
      font-weight: ${Fonts.SEMIBOLD};
    }
  }
`;

const StyledDropdown = styled(Dropdown)`
  border-color: var(--color-divider);
  padding: ${Spacings.SPACING_4B} 14px !important;
  box-shadow: none;
  height: ${Spacings.SPACING_14B};
  margin-top: ${Spacings.SPACING_4B};
  h6 {
    font-size: ${Fonts.SMALL};
    font-weight: ${Fonts.SEMIBOLD};
  }
`;

const Error = styled(P2)`
  font-weight: ${Fonts.SEMIBOLD};
  color: var(--color-i-red);
  margin-top: ${Spacings.SPACING_2B};
`;

const DialogEnquiryGoalDetails = ({ registrar, fields }) => {
  const goalDetailsKeys = Object.keys(fields ?? {});
  const goalKey = goalDetailsKeys.find((key) => key === 'Goal');
  const centreKey = goalDetailsKeys.find((key) => key === 'Centre');

  return (
    <FormContainer>
      {fields && goalDetailsKeys?.length ? (
        <>
          {goalKey && (
            <FieldWrapper>
              <Field
                registrar={registrar}
                name={goalKey}
                rules={[isRequired(`${goalKey} is required`)]}
                render={({ onChange, value }) => (
                  <StyledDropdown
                    options={fields[goalKey].options}
                    placeholder="Select your target exam"
                    selectedOption={value}
                    onOptionClick={(data) => onChange(data)}
                    buttonWidth="100%"
                    menuWidth="320px"
                  />
                )}
                renderError={renderErrorMessage}
              />
            </FieldWrapper>
          )}
          {!fields.Centre.isHidden && (
            <FieldWrapper>
              <Field
                registrar={registrar}
                name={centreKey}
                rules={[isRequired(`${centreKey} is required`)]}
                render={({ onChange, value }) => (
                  <StyledDropdown
                    options={fields[centreKey].options}
                    placeholder="Select your city of origin"
                    selectedOption={value}
                    onOptionClick={(data) => onChange(data)}
                    buttonWidth="100%"
                    menuWidth="320px"
                  />
                )}
                renderError={renderErrorMessage}
              />
            </FieldWrapper>
          )}
        </>
      ) : null}
    </FormContainer>
  );
};

export default DialogEnquiryGoalDetails;
